import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { setupStore } from './store/configureStore';
import ForgotPasswordWrapperComponent from './containers/ForgotPasswordWrapperComponent';

const store = setupStore();
const rootElement = document.querySelector('.app-password-container');
 
const root = createRoot(rootElement!);
root.render(
  <StrictMode>
    <Provider store={store}>
      <Router>
        <ForgotPasswordWrapperComponent />
      </Router>
    </Provider>
  </StrictMode>,
);
